export default "__VITE_ASSET__BQodJ5I___"